/** Array.from("\x89MCAP0\r\n", (c) => c.charCodeAt(0)) */
export const MCAP0_MAGIC = Object.freeze([137, 77, 67, 65, 80, 48, 13, 10]);
export var Opcode;
(function (Opcode) {
    Opcode[Opcode["MIN"] = 1] = "MIN";
    Opcode[Opcode["HEADER"] = 1] = "HEADER";
    Opcode[Opcode["FOOTER"] = 2] = "FOOTER";
    Opcode[Opcode["SCHEMA"] = 3] = "SCHEMA";
    Opcode[Opcode["CHANNEL"] = 4] = "CHANNEL";
    Opcode[Opcode["MESSAGE"] = 5] = "MESSAGE";
    Opcode[Opcode["CHUNK"] = 6] = "CHUNK";
    Opcode[Opcode["MESSAGE_INDEX"] = 7] = "MESSAGE_INDEX";
    Opcode[Opcode["CHUNK_INDEX"] = 8] = "CHUNK_INDEX";
    Opcode[Opcode["ATTACHMENT"] = 9] = "ATTACHMENT";
    Opcode[Opcode["ATTACHMENT_INDEX"] = 10] = "ATTACHMENT_INDEX";
    Opcode[Opcode["STATISTICS"] = 11] = "STATISTICS";
    Opcode[Opcode["METADATA"] = 12] = "METADATA";
    Opcode[Opcode["METADATA_INDEX"] = 13] = "METADATA_INDEX";
    Opcode[Opcode["SUMMARY_OFFSET"] = 14] = "SUMMARY_OFFSET";
    Opcode[Opcode["DATA_END"] = 15] = "DATA_END";
    Opcode[Opcode["MAX"] = 15] = "MAX";
})(Opcode || (Opcode = {}));
export function isKnownOpcode(opcode) {
    return opcode >= Opcode.MIN && opcode <= Opcode.MAX;
}
//# sourceMappingURL=constants.js.map